import React from 'react';
import { Link } from 'react-router-dom';

const formatPrice = (price) =>
  Number(price || 0).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });

function ProductCard({ product }) {
  const stockLabel = product.quantity > 0 ? `${product.quantity} available` : 'Sold out';
  const seller = product.addedBy?.username || 'Marketplace seller';

  return (
    <article className="product-card">
      <Link className="product-card-image" to={`/product/${product._id}`}>
        <img src={product.images?.[0]} alt={product.name} />
        <span className={`stock-badge ${product.quantity === 0 ? 'sold-out' : ''}`}>{stockLabel}</span>
      </Link>
      <div className="product-card-body">
        <Link className="product-card-title" to={`/product/${product._id}`}>{product.name}</Link>
        <div className="product-card-price">{formatPrice(product.price)}</div>
        <p>{product.description}</p>
        <div className="product-card-meta">
          <span>Seller: {seller}</span>
          <span>Free local pickup</span>
        </div>
      </div>
      <Link to={`/product/${product._id}`} className="button button-secondary button-full">
        View Item
      </Link>
    </article>
  );
}

export default ProductCard;
